export default "__VITE_ASSET__DRxiIWII__"